<template lang="pug">
.sow-info(v-loading="loading")
  title-bar {{ $t('项目信息') }}
  .info-display
    template(
      v-if="sowInfo.sub_final_scope_id"
    )
      el-row(:gutter="20")
        el-col(:span="24")
          .info_label {{ $t('名称') }}
          .info_content {{ sowInfo.sub_final_scope_name }}
      el-row(:gutter="20")
        el-col(:span="24")
          .info_label {{ $t('供应商类型') }}
          .info_content {{ sowInfo.is_storage === 1 ? $t('核心') :sowInfo.is_storage === 0 ? $t('非核心') : $t('非总库') }}
      el-row(:gutter="20")
        el-col(:span="24")
          .info_label {{ $t('供应商名称') }}
          .info_content {{ sowInfo.vendor_name }}
      el-row(:gutter="20" v-if="sowInfo.spotplan_path")
        el-col(:span="24")
          .info_label {{ $t('附件') }}
          .info_content
            a(
              v-if="sowInfo.spotplan_path.file_download_path"
              :href="sowInfo.spotplan_path.file_download_path"
              traget="_blank"
            ) {{ sowInfo.spotplan_path.file_name  }}
            span(v-else) —
      el-row(:gutter="20")
        el-col(:span="24")
          .info_label {{ $t('描述') }}
          .info_content {{ sowInfo.remark ? sowInfo.remark : '—' }}
    template(
      v-else
    )
      el-row(:gutter="20")
        el-col.required(:span="4") {{ $t('名称') }}
        el-col(:span="10")
          el-input(v-model="form.sub_final_scope_name" style="width: 220px")
      el-row(:gutter="20")
        el-col.required(:span="4") {{ $t('供应商类型') }}
        el-col(:span="10")
          el-radio-group(
            v-model="form.is_storage"
            @change="qs = ''"
          )
            el-radio(:label="1") {{ $t('核心') }}
            el-radio(:label="0") {{ $t('非核心') }}
            el-radio(:label="3") {{ $t('非总库') }}
      el-row(:gutter="20")
        el-col.required(:span="4") {{ $t('供应商') }}
        el-col(:span="10")
          el-autocomplete(
            v-model="qs"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('请输入供应商关键字')"
            value-key="struct_group_name"
            @select="handleSelect"
            popper-class="shortcut-category__autocomplete"
            style="width: 210px"
          )
      el-row.row-content(:gutter="20")
        el-col(:span="4") {{ $t('附件') }}
        el-col(:span="10")
          div(
            :style="{ display: 'flex',alignItems: 'center' }"
          )
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="res => uploadSuccess(res)"
            )
            uploaded-file-display(
              style="margin-left: 5px"
              class="uploaded-file-display"
              :fileName="form.spotplan_name"
              :downloadUrl="form.spotplan_download_path"
              width="140px"
            )
      el-row
        el-col(:span="4") {{ $t('描述') }}
        el-col(:span="20")
          el-input(
            v-model="form.remark"
            type="textarea"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
      el-row.row-content(:gutter="20")
        el-col(:span="10" :offset="4")
          footer-button(
            @confirm="onConfirm"
            @cancel="$router.push('/unistar/campaign-overview')"
          )
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import { format4backend } from '@/umcc/util'
export default {
  components: {
    TitleBar,
    FooterButton,
    NewUploadFile,
    UploadedFileDisplay
  },
  data () {
    return {
      form: {
        sub_final_scope_name: '',
        is_storage: null,
        vendor_name: '',
        vendor_id: null,
        spotplan_download_path: '',
        spotplan_name: '',
        spotplan_path: '',
        remark: ''
      },
      qs: '',
      loading: false
    }
  },
  async mounted () {
    if (this.sowInfo.sub_final_scope_id) {
      this.loading = true
      await this.$store.dispatch('unistar/getProcessTasks', {
        business_key: this.sowInfo.sub_final_scope_id,
        business_type: this.sowInfo.business_type,
        phase_type: 2
      })
      await this.$store.dispatch('unistar/getSOWInfo', this.sowInfo.sub_final_scope_id)
      this.loading = false
    } else {
      this.$store.commit('unistar/setDefaultSowProcess')
      this.form = this.sowInfo
      this.qs = this.sowInfo.vendor_name
    }
  },
  methods: {
    uploadSuccess (res) {
      this.form.spotplan_download_path = res.file_download_url
      this.form.spotplan_name = res.file_name
      this.form.spotplan_path = res.file_path
    },
    handleSelect (item) {
      this.form.vendor_id = item.struct_group_id
      this.form.vendor_name = item.struct_group_name
    },
    async querySearchAsync (queryString, cb) {
      const nullList = []
      if (queryString === '' && this.form.is_storage !== 1 && this.form.is_storage !== 0 && this.form.is_storage !== 3) {
        cb(nullList)
        return
      }
      const params = { keyword: queryString }
      if (this.form.is_storage != null) {
        params.filter_condition = this.form.is_storage
      }

      const list = await axios.get('/admin/struct/getVendorList', { params })
      // temporary fix
      this.cb = cb
      cb(list)
    },
    onConfirm () {
      if (this.form.is_storage === null || !this.form.vendor_id || !this.form.sub_final_scope_name) {
        this.$message.error(this.$t('请填写必填项'))
        return
      }
      if (this.form.sub_final_scope_name.length > 50) {
        this.$message.error(this.$t('项目名称不多于50字'))
        return
      }
      this.$validator.validate().then(result => {
        if (result) {
          this.submit()
        }
      })
    },
    submit () {
      let params = {
        sub_final_scope: {
          campaign_id: this.campaignId,
          sub_final_scope_name: this.form.sub_final_scope_name,
          spotplan_path: this.form.spotplan_path,
          remark: this.form.remark
        },
        sub_final_scope_vendor: {
          is_storage: this.form.is_storage,
          vendor_id: this.form.vendor_id
        }
      }
      this.loading = true
      axios.post('/management/star/saveSow', format4backend(params)).then(res => {
        this.$store.dispatch('unistar/getCampaignInfo')
        this.$store.commit('unistar/setSOWInfo', res)
        this.$store.dispatch('unistar/getSOWList')
        this.$store.dispatch('unistar/getProcessTasks', {
          business_key: res.sub_final_scope_id,
          business_type: res.business_type,
          phase_type: 2
        })
        this.loading = false
      })
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.unistar.campaignInfo.campaign_id
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    },
    uploadParams () {
      return {
        campaign_id: 5,
        file_type: 1
      }
    }
  }
}
</script>

<style scoped lang="stylus">

</style>
